<template>
  <div class="ChartsGridConfiger">
    <div class="p-line"></div>
    <div class="p-name">图表单位配置</div>
    <div class="p-grid">
      <span>top</span>
      <el-input size="mini" v-model="unit.top" placeholder=""></el-input>
      <span>bottom</span>
      <el-input size="mini" v-model="unit.bottom" placeholder=""></el-input>
    </div>
    <div class="p-grid">
      <span>left</span>
      <el-input size="mini" v-model="unit.left" placeholder=""></el-input>
      <span>right</span>
      <el-input size="mini" v-model="unit.right" placeholder=""></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChartsUnitConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    unit: {
      deep: true,
      handler: function(newVal) {
        // console.log(newVal);
        this.commitCurrentPropertyData(newVal);
      },
    },
  },
  data() {
    return {
      unit: {
        top: '0',
        left: '10',
        right: '0',
        bottom: '0',
      },
    };
  },
  created() {
    this.initCurrentPropertyData();
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    initCurrentPropertyData() {
      this.unit = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ChartsGridConfiger {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .p-grid {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;

    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 65px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
